import * as React from 'react'
import { Switch, Route } from 'react-router-dom'
import { Login } from '@halo/portals/pre-auth/login'
import { classnames } from '@halo/_utils/classnames'
import { ExternalRoute } from '@halo/components/router/route'
import { AppContent, Layout } from '@pushly/aqe/lib/components'
import randomstring from 'randomstring'
import { AUTH0_AUTH_ROUTE_BASE, AUTH0_CLIENT_ID, AUTHORIZE_ROUTE } from '@halo/constants'
import { buildRouteFromHostname } from '@halo/_utils/session-helpers'
import { PlatformUserContext } from '@halo/providers/user-provider/user-provider'
import aqe from '@pushly/aqe'
import { ErrorPage } from '@halo/components/error-page/error-page'
import { useService } from '@pushly/aqe/lib/hooks/index'
import { AppState } from '@halo/stores/app.state'

export const PreAuth = () => {
    const user = React.useContext(PlatformUserContext)
    const appState = useService(AppState)
    return (
        <div className={classnames('portal', 'pre-auth')}>
            <Layout>
                <AppContent>
                    <Switch>
                        {!user.authenticated && <Route path="/" exact={true} component={Auth0Redirect} />}
                        <ExternalRoute path="/login" exact={true} component={Login} />
                        {!appState.appIsLoading && <Route component={ErrorPage} />}
                    </Switch>
                </AppContent>
            </Layout>
        </div>
    )
}

export const Auth0Redirect = (): any => {
    const authorizeRoute = buildRouteFromHostname(AUTH0_AUTH_ROUTE_BASE + AUTHORIZE_ROUTE)
    const audience = 'sailfish'

    const state = randomstring.generate()
    window.sessionStorage.setItem('sw_a0st', state)

    if (!window.location.pathname.includes('authorize')) {
        const redirectURL = [
            `${authorizeRoute}?response_type=code`,
            `client_id=${AUTH0_CLIENT_ID}`,
            `audience=${audience}`,
            `redirect_uri=${aqe.defaults.internalPlatformDomain}/authorize`,
            'scope=profile%20email%20offline_access',
            `state=${state}`,
        ]

        window.location.href = redirectURL.join('&')
    }

    return null
}
